import { memo } from "react";
import { ROUTE_SELECTED_CASING_COLOR } from "../CircuitPathsLayer/constants";
import { DestinationDot } from "./DestinationDot";
import type { DestinationMarkerProps } from "./types";

const HOVER_STYLE = { pointerEvents: "all", cursor: "pointer" } as const;
const DEFAULT_FILL_COLOR = "#22c55e";

export const DestinationMarker = memo(function DestinationMarker({
  x,
  y,
  isSelected,
  opacity,
  isHoverEnabled = true,
  fillColor = DEFAULT_FILL_COLOR,
  strokeColor,
}: DestinationMarkerProps) {
  const hoverStyle = isHoverEnabled ? HOVER_STYLE : undefined;

  if (isSelected) {
    return (
      <DestinationDot
        x={x}
        y={y}
        ringColor={ROUTE_SELECTED_CASING_COLOR}
        hoverStyle={hoverStyle}
      />
    );
  }

  return (
    <DestinationDot
      x={x}
      y={y}
      ringColor={strokeColor ?? fillColor}
      opacity={opacity}
      hoverStyle={hoverStyle}
    />
  );
});
